import { MapPin, CheckCircle2 } from "lucide-react";

const regions = [
  "London & South East",
  "South West",
  "Isle of Wight",
  "Midlands",
  "North West & North East",
  "Wales & Scotland",
];

const Coverage = () => (
  <section className="bg-white py-16 md:py-20">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 md:px-8 lg:grid-cols-2">
      <div className="relative flex items-center justify-center">
        <div className="pointer-events-none absolute h-64 w-64 rounded-full bg-blue-100/50 blur-3xl" />
        <img
          src="https://cdn.pixabay.com/photo/2016/04/06/18/14/great-britain-1312450_1280.png"
          alt="Map of the United Kingdom"
          className="relative z-10 h-auto w-64 opacity-90 md:w-80"
        />
        <span className="absolute bottom-10 right-16 z-20 flex items-center gap-1.5 rounded-full bg-[#1d4ed8] px-3 py-1.5 text-xs font-semibold text-white shadow-lg">
          <MapPin size={13} /> Isle of Wight
        </span>
      </div>

      <div>
        <p className="eyebrow text-[#1d4ed8]">Where We Work</p>
        <h2 className="heading-xl mt-3 text-3xl text-[#0f2a5a] md:text-4xl">
          Covering all of mainland UK
        </h2>
        <div className="ld-accent-bar mt-5" />
        <p className="mt-6 text-base leading-relaxed text-gray-600">
          L&amp;D Controls provides supply and installation across the whole of mainland UK
          &mdash; including the Isle of Wight. From a single residential window opener to large
          commercial and public building projects, our team travels to you.
        </p>
        <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {regions.map((r) => (
            <div key={r} className="flex items-center gap-2.5 text-sm text-gray-700">
              <CheckCircle2 size={18} className="shrink-0 text-[#1d4ed8]" /> {r}
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Coverage;
